//react
import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Mobile, PC } from "../../media/MediaQuery";

//css
import styled from "styled-components";

// component
import DeliveryModal from "../popup/DeliveryModal";
import CancelModal from "../popup/CancelModal";
import ExchangeModal from "../popup/ExchangeModal";
import RefundModal from "../popup/RefundModal";
import DefaultModal from "../popup/DefaultModal";

// responsive
import { M, T } from "../../utils/MT";

export default function MypageBtn(props) {
    // 모달리스트
    // 1. 배송 조회 모달
    const [deliveryModal, setDeliveryModal] = useState(false);
    // 2. 주문 취소 모달
    const [cancelModalOpen, setCancelModalOpen] = useState(false);
    // 3. 주문 교환 모달
    const [exChangelModalOpen, setExChangelModalOpen] = useState(false);
    // 4. 주문 반품 모달
    const [refundModalOpen, setRefundModalOpen] = useState(false);
    // 5. 주문 취소/교환/반품 완료 모달
    const [completeModal1, setCompleteModal1] = useState(false);
    const [completeModal2, setCompleteModal2] = useState(false);
    const [completeModal3, setCompleteModal3] = useState(false);

    // 1. 배송 조회 모달
    const DeliveryModalCon = () => {
        return <DeliveryModal setDeliveryModal={setDeliveryModal} />;
    };

    // 2. 주문 취소 모달
    const CancelModalCon = () => {
        return <CancelModal setCancelModal={setCancelModalOpen} setCompleteModal={setCompleteModal1} />;
    };

    // 3. 주문 교환 모달
    const exChangelModalCon = () => {
        return <ExchangeModal setExChangelModalOpen={setExChangelModalOpen} setCompleteModal={setCompleteModal2} />;
    };

    // 4. 주문 반품 모달
    const refundModalCon = () => {
        return <RefundModal setRefundModalOpen={setRefundModalOpen} setCompleteModal={setCompleteModal3} />;
    };

    // 5. 주문 취소/교환/반품 완료 모달
    const modalTextList = (type) => {
        switch (type) {
            case 0:
                return <>취소 신청이 완료되었습니다.</>;
            case 1:
                return <>교환 신청이 완료되었습니다.</>;
            case 2:
                return <>반품 신청이 완료되었습니다.</>;
            default:
            // do nothing
        }
    };

    // 상품 진행상태 케이스문
    const btnList = (btnType) => {
        switch (btnType) {
            case 0:
                return (
                    <StateWrap>
                        <State>취소신청</State>
                    </StateWrap>
                );
            case 1:
                return (
                    <StateWrap>
                        <State>취소 완료</State>
                    </StateWrap>
                );
            case 2:
                return (
                    <StateWrap>
                        <State>교환신청</State>
                    </StateWrap>
                );
            case 3:
                return (
                    <StateWrap>
                        <State>교환완료</State>
                    </StateWrap>
                );
            case 4:
                return (
                    <StateWrap>
                        <State>반품신청</State>
                    </StateWrap>
                );
            case 5:
                return (
                    <StateWrap>
                        <State>반품완료</State>
                    </StateWrap>
                );
            case 6:
                return (
                    <StateWrap>
                        <StateLine>
                            <State>상품준비중</State>
                            <OrderBtn
                                onClick={() => {
                                    setCancelModalOpen(true);
                                }}
                            >
                                주문취소
                            </OrderBtn>
                        </StateLine>
                    </StateWrap>
                );
            case 7:
                return (
                    <StateWrap>
                        <StateLine>
                            <State>입금완료</State>
                            <OrderBtn
                                onClick={() => {
                                    setCancelModalOpen(true);
                                }}
                            >
                                주문취소
                            </OrderBtn>
                        </StateLine>
                    </StateWrap>
                );
            case 8:
                return (
                    <StateWrap>
                        <StateLine>
                            <State>배송 중</State>
                            <OrderBtn
                                onClick={() => {
                                    setDeliveryModal(true);
                                }}
                            >
                                배송조회
                            </OrderBtn>
                        </StateLine>
                        <DelNotice>
                            <DelDate>2021.03.12~2021.03.09 이내 출고</DelDate>
                            <DelCompany>
                                CJ대한통운
                                <span
                                    onClick={() => {
                                        setDeliveryModal(true);
                                    }}
                                >
                                    638908188030
                                </span>
                            </DelCompany>
                        </DelNotice>
                    </StateWrap>
                );
            case 9:
                return (
                    <StateWrap>
                        <StateLine>
                            <State>배송완료</State>

                            <StateBtnWrap>
                                <OrderBtn
                                    small
                                    onClick={() => {
                                        setExChangelModalOpen(true);
                                    }}
                                >
                                    교환
                                </OrderBtn>
                                <OrderBtn
                                    small
                                    onClick={() => {
                                        setRefundModalOpen(true);
                                    }}
                                >
                                    반품
                                </OrderBtn>
                            </StateBtnWrap>
                        </StateLine>
                    </StateWrap>
                );
            default:
            // do nothing
        }
    };

    return (
        <>
            {btnList(props.state)}
            {/* 모달리스트 */}

            {/* 1. 배송 조회 모달 */}
            {deliveryModal && <DefaultModal closeModal={() => setDeliveryModal(false)} contents={DeliveryModalCon} />}
            {/* 2. 주문 취소 모달 */}
            {cancelModalOpen && <DefaultModal closeModal={() => setCancelModalOpen(false)} contents={CancelModalCon} />}
            {/* 3. 주문 교환 모달 */}
            {exChangelModalOpen && <DefaultModal closeModal={() => setExChangelModalOpen(false)} contents={exChangelModalCon} />}
            {/* 4. 주문 반품 모달 */}
            {refundModalOpen && <DefaultModal closeModal={() => setRefundModalOpen(false)} contents={refundModalCon} />}
            {/* 5. 주문 취소/교환/반품 완료 모달 */}
            {completeModal1 && <DefaultModal closeModal={() => setCompleteModal1(false)} Simple={true} text={modalTextList(0)} />}
            {completeModal2 && <DefaultModal closeModal={() => setCompleteModal2(false)} Simple={true} text={modalTextList(1)} />}
            {completeModal3 && <DefaultModal closeModal={() => setCompleteModal3(false)} Simple={true} text={modalTextList(2)} />}
        </>
    );
}

// orderDetail
const StateWrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    @media screen and (max-width: 900px) {
        min-width: ${M(110)};
        margin-top: ${M(15)};
    }
`;
const StateLine = styled.div`
    text-align: center;
    @media screen and (max-width: 900px) {
        margin-left: auto;
    }
`;
const State = styled.div`
    /* 이거 왜이찌 */
    /* width: calc(100vw * (210 / 1920)); */
    width: 100%;
    font-size: calc(100vw * (20 / 1920));
    text-align: center;
    font-family: "Noto-B";

    @media screen and (max-width: 1300px) {
        /* width: calc(100vw * (210 / 1300)); */

        font-size: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: auto;
        font-size: ${M(16)};
    }
`;

const OrderBtn = styled.button`
    width: calc(100vw * (110 / 1920));
    height: calc(100vw * (35 / 1920));
    font-size: calc(100vw * (11 / 1920));

    color: var(--main-color);
    border: 1px solid var(--main-color);
    border-radius: 4px;

    margin-top: calc(100vw * (10 / 1920));

    &:only-of-type {
    }

    &:nth-of-type(2) {
        margin-bottom: calc(100vw * (7 / 1920));
    }

    ${({ small }) => {
        return (
            small &&
            `
                width: calc(100vw * (100 / 1920));
            `
        );
    }}

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (110 / 1300));
        height: calc(100vw * (35 / 1300));
        font-size: calc(100vw * (11 / 1300));

        margin-top: calc(100vw * (10 / 1300));

        ${({ small }) => {
            return (
                small &&
                `
                    width: calc(100vw * (100 / 1300));
                `
            );
        }}
    }

    @media screen and (max-width: 900px) {
        width: ${M(110)};
        height: ${M(35)};
        font-size: ${M(12)};

        margin-top: ${M(5)};

        ${({ small }) => {
            return (
                small &&
                `
                    width: ${M(100)};
                `
            );
        }}
    }
`;
const StateBtnWrap = styled.div`
    display: flex;

    & button:nth-child(2) {
        margin-left: calc(100vw * (10 / 1920));
    }

    @media screen and (max-width: 1300px) {
        & button:nth-child(2) {
            margin-left: calc(100vw * (10 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        flex-direction: column;

        & button:nth-child(2) {
            margin-left: 0;
        }
    }
`;

const DelNotice = styled.div`
    margin-top: calc(100vw * (10 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(10)};
    }
`;

const DelDate = styled.p`
    white-space: nowrap;
    font-size: calc(100vw * (13 / 1920));
    color: #aaaaaa;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (13 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
    }
`;
const DelCompany = styled.p`
    display: flex;
    align-items: center;
    justify-content: center;

    font-size: calc(100vw * (14 / 1920));
    color: #aaaaaa;

    & span {
        display: inline-block;
        margin-left: calc(100vw * (5 / 1920));

        color: var(--main-color);
        text-decoration-line: underline;

        cursor: pointer;
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));

        & span {
            margin-left: calc(100vw * (5 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        justify-content: flex-end;
        font-size: ${M(14)};

        & span {
            margin-left: ${M(5)};
        }
    }
`;
